import BLUE_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-blue.png";
import BLUE_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-blue.png";
import BLUE_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-blue.png";

import LIGHT_BLUE_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-lightblue.png";
import LIGHT_BLUE_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-lightblue.png";
import LIGHT_BLUE_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-lightblue.png";

import PINK_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-pink.png";
import PINK_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-pink.png";
import PINK_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-pink.png";

import PURPLE_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-purple.png";
import PURPLE_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-purple.png";
import PURPLE_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-purple.png";

import DARK_PURPLE_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-darkpurple.png";
import DARK_PURPLE_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-darkpurple.png";
import DARK_PURPLE_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-darkpurple.png";

import YELLOW_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-yellow.png";
import YELLOW_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-yellow.png";
import YELLOW_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-yellow.png";

import WHALE_TAIL_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-whale-tail.png";
import WHALE_TAIL_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-whale-tail.png";
import WHALE_TAIL_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-whale-tail.png";

import INDIGO_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-indigo.png";
import INDIGO_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-indigo.png";
import INDIGO_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-indigo.png";

import NEUTRAL_PATTERN_L from "@static/images/pages/dei/patterns/DEIPage-pattern-large-neutral.png";
import NEUTRAL_PATTERN_M from "@static/images/pages/dei/patterns/DEIPage-pattern-medium-neutral.png";
import NEUTRAL_PATTERN_S from "@static/images/pages/dei/patterns/DEIPage-pattern-small-neutral.png";

export const DEI_COLORS = {
  BLUE: {
    PATTERN_L: BLUE_PATTERN_L,
    PATTERN_M: BLUE_PATTERN_M,
    PATTERN_S: BLUE_PATTERN_S,
    HEX: '#034177',
  },
  LIGHT_BLUE: {
    PATTERN_L: LIGHT_BLUE_PATTERN_L,
    PATTERN_M: LIGHT_BLUE_PATTERN_M,
    PATTERN_S: LIGHT_BLUE_PATTERN_S,
    HEX: '#A0D4FF',
  },
  PINK: {
    PATTERN_L: PINK_PATTERN_L,
    PATTERN_M: PINK_PATTERN_M,
    PATTERN_S: PINK_PATTERN_S,
    HEX: '#FFB7B7',
  },
  PURPLE: {
    PATTERN_L: PURPLE_PATTERN_L,
    PATTERN_M: PURPLE_PATTERN_M,
    PATTERN_S: PURPLE_PATTERN_S,
    HEX: '#9FA6FF',
  },
  DARK_PURPLE: {
    PATTERN_L: DARK_PURPLE_PATTERN_L,
    PATTERN_M: DARK_PURPLE_PATTERN_M,
    PATTERN_S: DARK_PURPLE_PATTERN_S,
    HEX: '#404996',
  },
  YELLOW: {
    PATTERN_L: YELLOW_PATTERN_L,
    PATTERN_M: YELLOW_PATTERN_M,
    PATTERN_S: YELLOW_PATTERN_S,
    HEX: '#FFC555',
  },
  WHALE_TAIL: {
    PATTERN_L: WHALE_TAIL_PATTERN_L,
    PATTERN_M: WHALE_TAIL_PATTERN_M,
    PATTERN_S: WHALE_TAIL_PATTERN_S,
    HEX: '#034077',
  },
  INDIGO: {
    PATTERN_L: INDIGO_PATTERN_L,
    PATTERN_M: INDIGO_PATTERN_M,
    PATTERN_S: INDIGO_PATTERN_S,
    HEX: '#DFE7FF',
  },
  NEUTRAL: {
    PATTERN_L: NEUTRAL_PATTERN_L,
    PATTERN_M: NEUTRAL_PATTERN_M,
    PATTERN_S: NEUTRAL_PATTERN_S,
    HEX: '#E0E5E9',
  },
};
